import usePrivateAxios from '@/common/api/usePrivateAxios';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { DashboardData, DashboardResponse } from '../../types/dashboards/dashboard.type';

type UseDashboardType = (dashboardId: string | undefined) => UseQueryResult<DashboardData, unknown>;

export const useDashboard: UseDashboardType = (dashboardId) => {
  const privateAxios = usePrivateAxios();

  return useQuery<DashboardResponse, unknown, DashboardData>({
    enabled: !!dashboardId,
    queryKey: ['dashboard', dashboardId],
    queryFn: () => privateAxios.get(`/dashboards/${dashboardId}`),
    select: (data) => data?.data?.data,
  });
}
